$(document).ready(function () {
    $(".animsition-up").animsition({
        inClass: 'fade-in-up-sm',
        outClass: 'fade-out-down-sm',
        inDuration: 1500,
        outDuration: 800,
        linkElement: '.animsition-link',
        // e.g. linkElement: 'a:not([target="_blank"]):not([href^="#"])'
        loading: true,
        loadingParentElement: 'body', //animsition wrapper element
        loadingClass: 'animsition-loading',
        loadingInner: '<div id="loading"></div>', // e.g '<img src="loading.svg" />'
        timeout: false,
        timeoutCountdown: 5000,
        onLoadEvent: true,
        browser: ['animation-duration', '-webkit-animation-duration'],
        // "browser" option allows you to disable the "animsition" in case the css property in the array is not supported by your browser.
        // The default setting is to disable the "animsition" in a browser that does not support "animation-duration".
        overlay: false,
        overlayClass: 'animsition-overlay-slide',
        overlayParentElement: 'body',
        transition: function (url) {
            window.location.href = url;
        }
    });
    $(".animsition-left").animsition({
        inClass: 'fade-in-left-sm',
        outClass: 'fade-out-left-sm',
        inDuration: 1500,
        outDuration: 800,
        linkElement: '.animsition-link',
        // e.g. linkElement: 'a:not([target="_blank"]):not([href^="#"])'
        loading: true,
        loadingParentElement: 'body', //animsition wrapper element
        loadingClass: 'animsition-loading',
        loadingInner: '<div id="loading"></div>', // e.g '<img src="loading.svg" />'
        timeout: false,
        timeoutCountdown: 5000,
        onLoadEvent: true,
        browser: ['animation-duration', '-webkit-animation-duration'],
        // "browser" option allows you to disable the "animsition" in case the css property in the array is not supported by your browser.
        // The default setting is to disable the "animsition" in a browser that does not support "animation-duration".
        overlay: false,
        overlayClass: 'animsition-overlay-slide',
        overlayParentElement: 'body',
        transition: function (url) {
            window.location.href = url;
        }
    });
});

$(window).scroll(function () {
    var scroll = $(window).scrollTop();
    //>=, not <=
    if (scroll >= 100) {
        $('.toggle-nav').addClass('toggle-nav-mobile');
        $(".nav-onscroll").css('height', '60px');

        $('.logo-nav').addClass('logo-nav-mobile');
        $('.logo-nav svg').addClass('logo-mobile');
    } else {
        $('.toggle-nav').removeClass('toggle-nav-mobile');
        $(".nav-onscroll").css('height', '0px');
        $('.logo-nav svg').removeClass('logo-mobile');
        $('.logo-nav').removeClass('logo-nav-mobile');
    }
}); //missing );